import * as React from 'react';
import UserDetailHeader from '../Admin/userManagement/UserDetailHeader';
import { UserSponsorAcctList } from '../Admin/userManagement/UserSponsorAcctList';
import System from 'src/helper/system';
import AdminConsoleHeader from '../Admin/AdminConsoleHeader';
import ShippingAddressDetail from '../Admin/userManagement/ShippingAddressDetail';
import Constants from 'src/helper/Constants';
import RoleSelection from '../Admin/AdminModals/RoleSelection';
const c = System.getParams();

const UserDetail = () => {
  return (
    <>
      <div className='adminconsole-container'>
        <AdminConsoleHeader title={'USER DETAILS'} />
        <UserDetailHeader userId={c.uid} userType={c.userType} />

        {c.userType === Constants.siteUser.WEB && <ShippingAddressDetail userId={c.uid} />}
        {c.userType === Constants.siteUser.CORE && <UserSponsorAcctList userId={c.uid} />}
        <RoleSelection />
      </div>
    </>
  );
}

export default UserDetail;